<template>
  <div class="create-work-form" v-if="step === 0">
    <div class="header">
      <h2>Delete item</h2>
      <button class="close-btn" @click="close">×</button>
    </div>
    <div class="content w-full justify-center">
      Are you sure you want to remove this item?
    </div>
    <div class="footer">
      <button class="create-btn" @click="deleteWork">
        Delete
      </button>
      <button class="cancel-btn"  @click="cancel">
        Cancel
      </button>
    </div>
  </div>
  <div class="create-work-form" v-else>
    <div class="header">
      <button class="close-btn" @click="close">×</button>
    </div>
    <div class="content-2 w-full justify-center text-center">
      After this action, your item will be permanently deleted.
    </div>
    <div class="footer">

      <button class="cancel-btn-1"  @click="cancel">
        Cancel
      </button>
      <button class="create-btn-1" @click="deleteWork">
        Delete
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, computed, nextTick } from 'vue';
import Uploader from '~/components/works/profile/Uploader.vue';
import { useUserStore } from '~/composables/useUserStore';
import { useWorkStore } from '~/composables/useWorkStore';
import CategorySelector from '~/components/works/profile/CategorySelector.vue';
import * as pkg from 'vue-toastification';
const { useToast } = pkg;
const toast = useToast();
const { user } = useUserStore();
const props = defineProps({
  work: {
    type: Object,
    default: () => ({
      _id: '',
      title: '',
      tag: '',
      category: 'photography',
      coverImage: '',
      contentImages: [],
    }),
  },
});
const step = ref(1);
const emit = defineEmits(['close', 'deleteWork']);
const close = () => {
  emit('close');
};
const cancel = () => {

  emit('close');
};
const deleteWork = () => {
  if (step.value === 0) {
    step.value = 1;
  } else {
    emit('deleteWork', props.work);
  }
};

</script>

<style scoped>
.create-work-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  color: black;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 0 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.header h2 {
  font-size: 28px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 10px;
}

.content {
  display: flex;
  gap: 20px;
  padding: 0 20px;
}

.content-2 {
  display: block;
  padding: 0 20px;
  font-size: 28px;
  max-width: 100%;
  text-wrap: pretty;

}

.form-group {
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 14px;
}

.form-group small {
  display: block;
  margin-top: 10px;
  color: #b8b8b8;
  font-size: 8px;
  cursor: pointer;
}

.content-images {
  padding: 20px;
}

.content-images label {
  font-size: 14px;
  margin-bottom: 10px;
  display: block;
}

.content-image-horizontal {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
  padding: 10px;
  background: #ededed;
  border-radius: 10px;
  position: relative; /* Ensure it is relative for the absolute positioned popover */
}

.content-image-horizontal img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}

.footer {
  display: flex;
  justify-content: center;
  background: #EDEDED;
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  gap: 20px;
}

.add-btn {
  background-color: white;
  border: 1px solid #b8b8b8;
  padding: 0px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 12px;
  color: black;
}

.cancel-btn,
.create-btn {
  background-color: #ededed;
  border: none;
  min-width: 140px;
  padding: 5px 0;
  border-radius: 25px;
  color: #b8b8b8;
}

.cancel-btn-1,
.create-btn-1 {
  background-color: #fafafa;
  border: none;
  min-width: 140px;
  padding: 5px 0;
  border-radius: 25px;
  color: #b8b8b8;
}

.create-btn {
  background-color: #E3FF00;
  cursor: pointer;
  color: black;
}
.create-btn-1 {
  background-color: #dadada;
  cursor: pointer;
  color: #b8b8b8;
}

.add {
  border: 1px solid #b8b8b8;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.add img {
  width: 40px;
  height: 40px;
}
</style>
